/**
 * Görüntü yükleme sorunlarını tespit etmek için yardımcı fonksiyonlar
 */

// WebP formatı desteğini kontrol et
export const checkWebPSupport = () => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    if (canvas.getContext && canvas.getContext('2d')) {
      // WebP formatını destekliyor mu kontrol et
      canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0
        ? resolve(true)
        : resolve(false);
    } else {
      resolve(false);
    }
  });
};

// Görüntü URL'sini test et
export const testImageUrl = async (url) => {
  console.log(`Testing image URL: ${url}`);
  
  try {
    // URL geçerli mi kontrol et
    new URL(url);
    
    // CORS kontrolü
    const isCrossDomain = new URL(url, window.location.href).origin !== window.location.origin;
    console.log(`Is cross-domain: ${isCrossDomain}`);
    
    // WebP desteği kontrolü
    const webpSupported = await checkWebPSupport();
    console.log(`WebP format supported: ${webpSupported}`);
    
    // Görüntü formatı kontrolü
    const isWebP = url.toLowerCase().endsWith('.webp');
    console.log(`Image is WebP format: ${isWebP}`);
    
    // Uyumluluk uyarısı
    if (isWebP && !webpSupported) {
      console.warn("Browser does not support WebP format, image may not load correctly");
    }
    
    // Görüntüyü yüklemeyi dene
    const img = new Image();
    
    if (isCrossDomain) {
      img.crossOrigin = "anonymous";
    }
    
    return new Promise((resolve, reject) => {
      img.onload = () => {
        console.log(`Image dimensions: ${img.width}x${img.height}`);
        resolve({
          success: true,
          width: img.width,
          height: img.height,
          url
        });
      };
      
      img.onerror = (e) => {
        console.error(`Failed to load image: ${url}`, e);
        reject({
          success: false,
          error: e,
          url
        });
      };
      
      img.src = url;
    });
  } catch (error) {
    console.error(`Invalid image URL: ${url}`, error);
    return {
      success: false,
      error,
      url
    };
  }
};

// Mobil cihaz kontrolü
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// Tarayıcı bilgilerini al
export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  const browserInfo = {
    userAgent,
    isMobile: isMobileDevice(),
    webpSupported: null,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    pixelRatio: window.devicePixelRatio || 1
  };
  
  checkWebPSupport().then(supported => {
    browserInfo.webpSupported = supported;
    console.log('Browser information:', browserInfo);
  });
  
  return browserInfo;
};

// Görüntü yükleme hatalarını izle
export const monitorImageErrors = () => {
  window.addEventListener('error', function(e) {
    if (e.target.tagName === 'IMG') {
      console.error('Image loading error:', {
        src: e.target.src,
        alt: e.target.alt,
        time: new Date().toISOString()
      });
    }
  }, true);
  
  console.log('Image error monitoring enabled');
};

export default {
  checkWebPSupport,
  testImageUrl,
  isMobileDevice,
  getBrowserInfo,
  monitorImageErrors
}; 